define("shared/utils/array-filters/filter-time-series", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.filterTimeSeries = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f

  /**
   * Filters a timeseries dataset by a start and end date.
   *
   * @param data Array of objects, where each object has a time and value
   * @param startDateUnix Unix start date
   * @param endDateUnix Unix end date
   * @param keyName Name of the time key to filter data by
   *
   * @returns Array of objects which have time values within startDateUnix and endDateUnix
   */
  const filterTimeSeries = (data, startDateUnix, endDateUnix, timeKeyName) => {
    if ((0, _utils.isEmpty)(data)) {
      return [];
    } else if (!startDateUnix || !endDateUnix) {
      return data;
    }

    return data.filter(datum => startDateUnix <= Number(datum[timeKeyName]) && Number(datum[timeKeyName]) <= endDateUnix);
  };

  _exports.filterTimeSeries = filterTimeSeries;
  var _default = filterTimeSeries;
  _exports.default = _default;
});